export const getSearchParameter = (parameterName, pageHref) => {
  const url = new URL(pageHref ?? window.location.href);

  return url.searchParams.get(parameterName);
};
